"use client";

import AnimatedSection from "../../AnimatedSection";
import { Car } from "../../public/models/Car";
import { useState } from "react";
import CarPageClient from "./cars/[slug]/CarPageClient";
import Image from "next/image";
import { ENV } from "./environment/environment";
import { GiGearStickPattern } from "react-icons/gi";
import { FaUserFriends } from "react-icons/fa";


export const CarList: React.FC<{ cars: Car[] }> = ({ cars }) => {

    const [selectedCar, setSelectedCar] = useState<Car | null>(null);

    const handleCarClick = (car: Car) => {
        // Supprime la voiture si elle est déjà dans le tableau
        const index = cars.findIndex(c => c.id === car.id);
        if (index !== -1) {
            cars.splice(index, 1);
        }

        // Ajoute la voiture au début du tableau
        cars.unshift(car);
        setSelectedCar(car);
        document.title = car.name;
        window.history.pushState(null, '', `/cars/${encodeURIComponent(car.uniqueName)}`);
    };

    const handleCloseModal = () => {
        setSelectedCar(null);
    };


    return (
        <div className="max-w-6xl mx-auto px-4 py-12">
            {/* Section Nos Services */}



            {/* Section Nos Voitures */}
            <h2 className="text-3xl font-bold mt-16 mb-8  text-center text-4xl">Nos véhicules </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                {cars.map((car, index) => (
                    <AnimatedSection key={index}>

                        <div
                            onClick={() => handleCarClick(car)}
                            className="bg-white shadow min-h-[24rem] overflow-hidden cursor-pointer hover:shadow-md transition">
                            <Image
                                src={`${ENV.bucket}/images/${car.images?.[0]}`} // chemin dynamique
                                alt={car.name}
                                width={400} // ajuste selon ta maquette
                                height={256} // max-h-64 = 16rem = 256px
                                className="w-full object-contain bg-gray-100"
                                style={{ maxHeight: '16rem' }}
                            />


                            <div className="p-4">
                                <h4 className="text-2xl font-semibold">{car.name}</h4>
                            </div>
                            <div className="absolute bottom-0 bg-gray-100 text-black w-full grid grid-cols-2 gap-4 p-4">
                                <div className="inline-flex items-center">
                                    <GiGearStickPattern className="text-[1.5rem] mr-2" style={{ color: '#f8d340'}} />
                                    {car.transmission.charAt(0).toUpperCase() + car.transmission.slice(1)} 
                                </div>

                                <div className="inline-flex items-center">
                                    <FaUserFriends className="text-[1.5rem] mr-2" style={{ color: '#f8d340'}}/>
                                    {car.seats} seats
                                </div>
                            </div>

                        </div>
                    </AnimatedSection>

                ))}
            </div>

            {selectedCar && (
                <div className="fixed inset-0 z-50 bg-black bg-opacity-80 flex items-center justify-center">
                    <div className="bg-[#000] w-full h-full p-4 overflow-auto relative">
                        <button
                            style={{
                                width: '32px',
                                height: '32px',
                                background: '#000',
                                color: '#fff',
                                fontSize: '30px',
                                borderRadius: '50%',
                                lineHeight: '32px'
                            }}
                            onClick={handleCloseModal}
                            className="absolute top-4 right-4 text-black text-3xl font-bold z-10"
                        >
                            &times;
                        </button>
                        {/* <ProductPageClient product={selectedProduct} products={products} /> */}
                        <div className="container mx-auto relative bg-white p-[0.5rem]  sm:p-[2rem]" >
                            {/* <CarPageWrapper car={selectedCar} /> */}
                            <CarPageClient cars={cars} />
                        </div>

                    </div>
                </div>
            )}

        </div>
    )
}